// Wire ids from the agents module's `COPILOT_VIRTUAL_AGENT_IDS`; no agents-table
// rows exist behind them.
export const LIVE_ANALYTICS_VIRTUAL_AGENT_ID =
  "ffffffff-0000-4000-8000-000000000001";
export const LIVE_ANALYTICS_VIRTUAL_VERSION_ID =
  "ffffffff-0000-4000-8000-000000000002";
